import Vue from "vue";
import axios from "axios";
import qs from "qs";
import ElementUI from "element-ui";


if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = "/api";
} else {
  axios.defaults.baseURL = process.env.API_ENDPOINT;
}

export default {
  get(url, data) {
    return axios
      .get(url, {
        params: data
      });
  },
  getDetails(url, data) {
    return axios
      .get(url, {
        params: data
      });
  },
  getFile(url, data) {
    return axios
      .get(url, {
        params: data,
        timeout: 1000 * 60 * 10,
        responseType: "blob"
      });
  },
  getBuffer(url, data) {
    return axios
      .get(url, {
        params: data,
        responseType: "arraybuffer"
      });
  },
  post(url, data, config) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, qs.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          },
          timeout: 1000 * 60 * 15,
          ...config
        })
        .then(res => {
          if (res.status == 200) {
            resolve(res.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  postLogin(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, qs.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          },
          timeout: 1000 * 60 * 15
        })
        .then(res => {
          if (res.status == 200) {
            resolve(res.data);
          }
        })
        .catch(error => {
          ElementUI.Message({
            message: error.response.data.error_description,
            type: "error"
          });
          reject(error);
        });
    });
  },
  postReg(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          timeout: 1000 * 60 * 15
        })
        .then(res => {
          if (res.status == 200) {
            resolve(res.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  postJson(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          }
        })
        .then(res => {
          if (res.status == 200) {
            resolve(res.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  postFile(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, qs.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          },
          timeout: 1000 * 60 * 10,
          responseType: "blob"
        })
        .then(res => {
          if (res) {
            resolve(res);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  put(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          }
        })
        .then(res => {
          if (res.status == 200) {
            resolve(res.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delete(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url, {
          params: data
        })
        .then(res => {
          if (res.status == 200) {
            resolve(res.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  postUpload(url, file) {
    return new Promise((resolve, reject) => {
      let fd = new FormData();
      fd.append("file", file);
      axios
        .post(url, fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          if (res) {
            resolve(res);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};



// WEBPACK FOOTER //
// ./src/lib/request.js